import React from 'react';

import { IconLojaIntegrada } from '@paretogroup/tess';
import { Paragraph } from '../integration-strategies/modal-strategy/modal-strategy.styles';

import {
    SLOT_TITLE,
    TEST_ID,
    MODAL_TITLE,
    MODAL_SUBTITLE_INITIAL,
    MODAL_SUBTITLE_FINAL,
    API_TOKEN_LINK,
    APPCUES_ID,
} from './loja-integrada.constants';
import { LojaIntegrada } from './loja-integrada-modal';
import { features } from '../../feature-toggle/feature-toggle.constants';
import { createFeatureToggleModalIntegration } from '../integration-strategies';
import { ICON_SIZE, TEXTS } from '../integrations.constants';

const Subtitle = () => (
    <Paragraph>
        { MODAL_SUBTITLE_INITIAL }
        <a href={API_TOKEN_LINK} target="_blank" rel="noopener noreferrer">{ MODAL_SUBTITLE_FINAL }</a>
    </Paragraph>
);

export const lojaIntegradaIntegration = createFeatureToggleModalIntegration({
    id: 'loja_integrada',
    feature: features.reportIntegration,
    title: SLOT_TITLE,
    icon: <IconLojaIntegrada
        size={ICON_SIZE}
    />,
    testId: TEST_ID,
    modal: {
        title: MODAL_TITLE,
        subtitleComponent: Subtitle,
        body: LojaIntegrada,
    },
    dataAppcuesId: APPCUES_ID,
    subtitle: TEXTS.MAINTENANCE,
});
